import React, { Component, SFCElement } from 'react';
import If from '../if';
import modalServiceWrapper, { IWrapperConfig } from '../modalDialog/modalServiceWrapper';
import { Dialog, DialogBody, DialogFooter, DialogFooterButton, DialogHeader, IDialogProps } from '../dialog/dialog';

export interface IConfirmDialogProps extends IWrapperConfig, IDialogProps {
    showDialog?: boolean; // 是否显示弹窗
    hasMask?: boolean; // 是否显示遮罩层
    className?: string; // 自定义类名
    showClose?: boolean; // 是否显示右上角的关闭按钮
    title?: string; // 标题
    content?: string | SFCElement<any> | Array<SFCElement<any>>; // 内容
    btnConfirmText?: string; // 确定按钮文案
    btnCancelText?: string; // 取消按钮文案
    submitBtnClick?: () => void; // 确认按钮回调
    cancelBtnClick?: () => void; // 取消按钮回调
    close?: () => void; // 关闭弹窗
    afterClose?: () => void;
}

class NormalDialog extends Component<IConfirmDialogProps> {
    public static defaultProps = {
        showDialog: true,
        hasMask: true,
        className: '',
        showClose: true,
    };

    constructor(props: IConfirmDialogProps) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public componentDidUpdate() {
        const { showDialog, afterClose } = this.props;
        if (!showDialog && afterClose) {
            afterClose();
        }
    }

    public onCancel() {
        const { cancelBtnClick, close } = this.props;

        if (cancelBtnClick) {
            cancelBtnClick();
        }
        if (close) {
            close();
        }
    }

    public onSubmit() {
        const { submitBtnClick, close } = this.props;

        if (submitBtnClick) {
            submitBtnClick();
        }
        if (close) {
            close();
        }
    }

    public render() {
        const { close, showDialog, hasMask, className, showClose, title, content, btnConfirmText, btnCancelText } =
            this.props;
        return (
            <Dialog
                show={!!showDialog}
                hasMask={hasMask}
                className={`modal-dialog ${className}`}
                canClose={showClose}
                close={close}
            >
                <If condition={!!title}>
                    <DialogHeader>
                        <div className="title">{title}</div>
                    </DialogHeader>
                </If>
                <DialogBody>
                    <If condition={content instanceof String}>
                        <div className="info">{content}</div>
                    </If>
                    <If condition={!(content instanceof String)}>
                        <>{content}</>
                    </If>
                </DialogBody>
                <If condition={!!btnCancelText || !!btnConfirmText}>
                    <DialogFooter>
                        <If condition={!!btnCancelText}>
                            <DialogFooterButton onClick={this.onCancel}>{btnCancelText}</DialogFooterButton>
                        </If>
                        <If condition={!!btnConfirmText}>
                            <DialogFooterButton onClick={this.onSubmit}>{btnConfirmText}</DialogFooterButton>
                        </If>
                    </DialogFooter>
                </If>
            </Dialog>
        );
    }
}

export default modalServiceWrapper(NormalDialog);
